import {
  Component,
  OnInit,
  AfterViewInit,
  ViewChild,
  ElementRef,
  OnDestroy,
} from '@angular/core';
import {
  faArrowRight,
  faArrowLeft,
  faChevronRight,
  faChevronLeft,
  faArrowUp,
  faChevronUp,
  faPaperPlane,
  faPaperclip,
  faUser,
  faAt,
  faPhone,
  faComment,
  faCheck,
  faTimes,
} from '@fortawesome/free-solid-svg-icons';
import { gsap } from 'gsap';
import { CSSRulePlugin } from 'gsap/CSSRulePlugin';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// import anime.js
import anime from 'animejs/lib/anime.es.js';

// import Swiper bundle with all modules installed
import swiper from 'swiper/bundle';

import { magicMouse } from '../../../assets/js/magic_mouse.js';
import { DomSanitizer } from '@angular/platform-browser';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
// import { Email } from '../../../assets/js/smtp 2.js';

declare var $;

@Component({
  selector: 'app-careers',
  templateUrl: './careers.component.html',
  styleUrls: ['./careers.component.scss'],
})
export class CareersComponent implements OnInit, AfterViewInit, OnDestroy {
  [x: string]: any;
  faChevronLeft = faChevronLeft;
  faChevronRight = faChevronRight;
  faArrowLeft = faArrowLeft;
  faArrowRight = faArrowRight;
  faArrowUp = faArrowUp;
  faChevronUp = faChevronUp;
  faPaperPlane = faPaperPlane;
  faPaperclip = faPaperclip;
  faCheck = faCheck;
  faTimes = faTimes;

  userName: string = '';
  userEmail: string = '';
  userPhone: string = '';
  userCV: object = {};
  userCVuri;
  cvBlob: Blob;
  userCVName: string = '';
  @ViewChild('userCVRef') userCVRef: ElementRef;
  isPending: boolean = true;
  hasError: boolean = false;
  isLoading: boolean = false;
  isSent: boolean = false;

  errorMessage: string;

  careersForm$: Subscription;

  careersForm = new FormGroup({
    name: new FormControl('', Validators.required),
    email: new FormControl('', [
      Validators.required,
      Validators.email,
      Validators.pattern(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/),
    ]),
    phone: new FormControl('', [
      Validators.required,
      Validators.pattern(/^[+]{0,1}[\d]{9,13}$/),
    ]),
    // attachment: new FormControl(''),
    cv: new FormControl(''),
  });

  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit(): void {
    // Animations
    // Register plugins to be used and avoid bundler tree shaking losses
    gsap.registerPlugin(ScrollTrigger, ScrollToPlugin, CSSRulePlugin);
    // initialize magic mouse plugin
    const magicmouseoptions = {
      cursorOuter: 'circle-basic',
      hoverEffect: 'circle-move',
      hoverItemMove: true,
      defaultCursor: true,
      outerWidth: 40,
      outerHeight: 40,
    };
    magicMouse(magicmouseoptions);

    globalThis.scrollTo(0, 0);

    $('#magicMouseCursor').addClass('is-loading');
    const welcomeTL = gsap.timeline();
    welcomeTL
      .to('.loading-container', {
        z: 0.1,
        rotationZ: 0.01,
        force3D: true,
        autoAlpha: 1,
        duration: 1,
        ease: 'Power1.easeOut',
      })
      .to('.loading-container', {
        z: 0.1,
        rotationZ: 0.01,
        force3D: true,
        autoAlpha: 0,
        duration: 2,
        ease: 'Power1.easeOut',
      })
      .from(
        'main',
        {
          z: 0.1,
          rotationZ: 0.01,
          force3D: true,
          autoAlpha: 0,
          duration: 1,
          ease: 'Power3.easeOut',
        },
        '-=2'
      )
      .to('.loading-container', {
        z: 0.1,
        rotationZ: 0.01,
        force3D: true,
        y: '-100%',
        autoAlpha: 0,
        duration: 0.1,
        ease: 'Power2.easeOut',
      })

      .from(
        '.header-wrapper',
        {
          z: 0.1,
          rotationZ: 0.01,
          force3D: true,
          y: -100,
          // scale: 4,
          autoAlpha: 0,
          duration: 2,
          ease: 'Power3.easeOut',
        },
        '-=2'
      )
      .from(
        '.objective-wrapper',
        {
          z: 0.1,
          rotationZ: 0.01,
          force3D: true,
          y: -100,
          autoAlpha: 0,
          duration: 1.2,
          ease: 'Power3.easeOut',
        },
        '-=1.55'
      )
      .from('.careers-form-wrapper', {
        z: 0.1,
        rotationZ: 0.01,
        force3D: true,
        y: -50,
        autoAlpha: 0,
        ease: 'Power3.easeOut',
        duration: 1.2,
      });

    setTimeout(() => {
      $('#magicMouseCursor').removeClass('is-loading');
    }, 3000);

    this.careersForm$ = this.careersForm.valueChanges.subscribe((formData) => {
      console.log(formData);
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      //// on scroll

      gsap.from('.next-container', {
        z: 0.1,
        rotationZ: 0.01,
        force3D: true,
        y: -100,
        autoAlpha: 0,
        ease: 'power1.out',
        scrollTrigger: {
          trigger: '.next-container',
          scrub: 3,
          start: 'top bottom',
          end: 'bottom bottom',
        },
      });
    }, 0);
  }
  ngOnDestroy(): void {
    this.careersForm$.unsubscribe();
  }

  selectedCVFile: File | null = null;

  fileChangeEvent(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedCVFile = input.files[0];
      this.userCVName = this.selectedCVFile.name;
    }
  }

  careersMail() {
    if (this.careersForm.invalid || !this.selectedCVFile) return;

    this.isLoading = true;
    this.hasError = false;
    this.isSent = false;

    const reader = new FileReader();
    reader.onload = () => {
      const base64CV = (reader.result as string).split(',')[1];

      const payload = {
        name: this.careersForm.get('name')?.value,
        email: this.careersForm.get('email')?.value,
        phone: this.careersForm.get('phone')?.value,
        filename: this.selectedCVFile!.name,
        cv: base64CV,
      };

      fetch(
        'https://script.google.com/macros/s/AKfycbz9G7Sm8an-ZX3oRiMYWHtgvj_ouK5fj1T18sIW_w32h7qR00he67eA8s2J1p2VRdU8/exec',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: this.encodeFormData(payload),
        }
      )
        .then((response) => {
          console.log('Raw response:', response);
          return response.text();
        })
        .then((result) => {
          console.log('Response text:', result);
          this.isLoading = false;

          // Flexible success check
          if (result && result.toLowerCase().includes('success')) {
            this.isSent = true;
            this.hasError = false;
            this.careersForm.reset();
            this.selectedCVFile = null;
            if (this.fileInput) {
              this.fileInput.nativeElement.value = '';
            }
          } else {
            throw new Error(
              result || 'Submission failed with no error message'
            );
          }
        })
        .catch((error) => {
          console.error('Full error:', error);
          this.hasError = true;
          this.isSent = false;
          this.isLoading = false;
          alert(`Error: ${error.message || 'Unknown error occurred'}`);
        });
    };

    reader.onerror = (error) => {
      console.error('FileReader error:', error);
      this.isLoading = false;
      this.hasError = true;
      alert('Failed to read the file. Please try again.');
    };

    reader.readAsDataURL(this.selectedCVFile);
  }

  encodeFormData(data: { [key: string]: string }): string {
    return Object.keys(data)
      .map(
        (key) => encodeURIComponent(key) + '=' + encodeURIComponent(data[key])
      )
      .join('&');
  }

  // handleUpload(event) {
  //   const file = event.target.files[0];
  //   const reader = new FileReader();
  //   // reader.readAsDataURL(file);
  //   reader.onload = () => {
  //       this.userCVuri = reader.result;
  //   };
  // }

  async dataURItoBlob(dataURI) {
    // convert base64 to raw binary data held in a string
    // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
    var byteString = atob(dataURI.split(',')[1]);

    // separate out the mime component
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

    // write the bytes of the string to an ArrayBuffer
    var ab = new ArrayBuffer(byteString.length);

    // create a view into the buffer
    var ia = new Uint8Array(ab);

    // set the bytes of the buffer to the correct values
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    // write the ArrayBuffer to a blob, and you're done
    var blob = new Blob([ab], { type: mimeString });
    return await blob;
  }
}
